import { useEffect, useRef, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";

const LABELS = { view: "VIEW", play: "PLAY", open: "OPEN", drag: "DRAG" };

export const Cursor = () => {
  const dot = useRef(null);
  const [state, setState] = useState(null);
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();

  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    document.body.classList.add("hsk-cursor");

    const target = { x: 0, y: 0 };
    const pos = { x: 0, y: 0 };
    let raf;

    const onMove = (e) => {
      target.x = e.clientX;
      target.y = e.clientY;
      setVisible(true);
      const el = e.target.closest?.("[data-cursor]");
      setState(el ? el.getAttribute("data-cursor") : null);
    };
    const onLeave = () => setVisible(false);

    const tick = () => {
      pos.x += (target.x - pos.x) * 0.22;
      pos.y += (target.y - pos.y) * 0.22;
      if (dot.current) {
        dot.current.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseleave", onLeave);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseleave", onLeave);
      document.body.classList.remove("hsk-cursor");
    };
  }, []);

  if (reduce) return null;

  return (
    <div
      ref={dot}
      data-testid="custom-cursor"
      className="pointer-events-none fixed left-0 top-0 z-[80] hidden md:block"
      style={{ opacity: visible ? 1 : 0, transition: "opacity .25s ease" }}
    >
      <div className="relative -translate-x-1/2 -translate-y-1/2">
        <motion.div
          animate={{ scale: state ? 0 : 1 }}
          transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
          className="h-[6px] w-[6px] rounded-full bg-[#d4ff00]"
        />
        <motion.div
          animate={{ scale: state ? 1 : 0.4, opacity: state ? 1 : 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        >
          <div className="flex h-[62px] w-[62px] items-center justify-center rounded-full border border-[#d4ff00] bg-[#d4ff00]/10 backdrop-blur-[2px]">
            <span className="label text-[9px] text-[#d4ff00]">
              {LABELS[state] || ""}
            </span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
